import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule, ModalModule } from 'ngx-bootstrap';
import 'url-search-params-polyfill';
import { AppRoutingModule } from './app-routing-module';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { HeaderComponent } from './header/header.component';
import { PrivateComponent } from './layout/private/private.component';
import { PublicComponent } from './layout/public/public.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { PublicGuard } from './shared/guards/public.gaurd';
import { SharedModule } from './shared/shared.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { Ng5SliderModule } from 'ng5-slider';
import { ConfirmDialogService } from './shared/confirm-dialog/confirm-dialog.service';
import { LoaderService } from './shared/loader/loader.service';
import { FlashMessagesModule } from './shared/flash-messages/flash-messages.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NiceSelectModule } from 'ng-nice-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    PrivateComponent,
    HeaderComponent,
    SidebarComponent,
    NotFoundComponent,

  ],
  imports: [
    NiceSelectModule,
    BrowserAnimationsModule,
    Ng5SliderModule,
    AngularFontAwesomeModule,
    ShowHidePasswordModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    BrowserModule,
    HttpModule,
    SharedModule,
    AppRoutingModule,
    FlashMessagesModule,
    HttpClientModule,
    NgSelectModule, FormsModule
  ],
  providers: [
    ConfirmDialogService,
    LoaderService,
    AppConfig,
    AuthGuard,
    PublicGuard
  ],
  bootstrap: [AppComponent,]
})

export class AppModule { DatepickerModule; }
